import { deepAssign, get } from './utils';
var install = function install(Vue, options) {
  var proto = Vue.prototype;
  proto.$si18n = proto.$si18n || {};
  // 初始化多语言
  deepAssign(proto.$si18n, options);
  var _vm = new Vue({
    data: options
  });
  Object.defineProperty(Vue.prototype.$si18n, 'lang', {
    get: function get() {
      return _vm.lang;
    }
  });
  proto.$st = function (path) {
    var messages = _vm.messages[_vm.lang];
    if (!proto.$si18n.messages) {
      if (process.env.NODE_ENV !== 'production') {
        console.error('[yxI18n] Locale not correctly registered');
      }
      return function () {
        return path;
      };
    }
    //const message = get(messages, path) || get(messages, path)
    var message = get(messages, path);
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return typeof message === 'function' ? message.apply(void 0, args) : message !== null ? message : path;
  };
  proto.$st2 = function (path, path2) {
    var messages = _vm.messages[_vm.lang];
    var message = get(messages, path);
    return message !== null ? message : get(messages, path2);
  };
  proto.$si18n.add = function () {
    var messages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    deepAssign(proto.$si18n.messages, messages);
  };
  proto.$si18n.setLang = function (lang) {
    _vm.lang = lang;
  };
  Vue.mixin({
    beforeCreate: function beforeCreate() {
      this.$options.i18n && this.$si18n.add(this.$options.i18n);
    }
  });
};
export default {
  install: install
};